import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';

import { useFadeIn } from './hooks';

import { Classname } from 'utils/types';

const Container = styled.div``;

interface IFadeIn extends PropsWithChildren, Classname {
  as?: React.ElementType;
}

export const FadeIn: React.FC<IFadeIn> = ({ children, className, as }) => {
  const ref = useFadeIn();

  return (
    <Container className={className} ref={ref} as={as}>
      {children}
    </Container>
  );
};
